/** @file Rounds a computed setup value to 1e-6 and turns -0 into 0 (no float noise in documents). */

/** `v` rounded to 1e-6, never -0: setup values derived from matrix inversions carry no float noise. */
export function snapSetup(v: number): number {
  return Math.round(v * 1e6) / 1e6 + 0;
}
